import React from 'react';
import ReactDOM from 'react-dom';
import './twitter.css';

class Twitter extends React.Component {
  render(){
    return(
      <p>
      <a className="twitter-timeline" href="https://twitter.com/creesoo?ref_src=twsrc%5Etfw">
      Tweets by creesoo</a>
      <script async src="//platform.twitter.com/widgets.js" charset="utf-8">
      </script>
      </p>
   );
  }

}

export default Twitter;



// WEBPACK FOOTER //
// ./src/twitter/twitter.js